import { Reveal, Overline } from "@/components/site/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/i18n/assets";

const chapterImages = [IMAGES.foggyCastle, IMAGES.irishCoast, IMAGES.glencoeHouse];

export function Manifesto() {
  const { t } = useLanguage();

  return (
    <section id="origins" data-testid="manifesto-section" className="relative bg-clan-bg py-28 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <Overline>{t.manifesto.overline}</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight text-clan-ink sm:text-5xl lg:text-6xl pearl">
              {t.manifesto.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-20 flex flex-col gap-24">
          {t.manifesto.chapters.map((c, i) => (
            <div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              className={`grid items-center gap-10 lg:grid-cols-12 lg:gap-16 ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <Reveal className="lg:col-span-6 lg:[direction:ltr]" y={40}>
                <div className="group relative overflow-hidden rounded-lg border border-clan-ink/10">
                  <div
                    className="aspect-[4/3] w-full bg-cover bg-center transition-transform duration-[900ms] ease-out group-hover:scale-105"
                    style={{ backgroundImage: `url(${chapterImages[i % chapterImages.length]})` }}
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-clan-bg/70 to-transparent opacity-60" />
                  <span className="absolute bottom-5 left-5 font-mono text-xs uppercase tracking-[0.25em] text-clan-ink/80">
                    Clann Dòmhnaill
                  </span>
                </div>
              </Reveal>

              <div className="lg:col-span-6 lg:[direction:ltr]">
                <Reveal delay={0.1}>
                  <span className="font-mono text-6xl font-medium text-clan-primary/70 lg:text-7xl">{c.num}</span>
                </Reveal>
                <Reveal delay={0.18}>
                  <h3 className="mt-4 font-serif text-3xl font-medium text-clan-ink lg:text-4xl">{c.title}</h3>
                </Reveal>
                <Reveal delay={0.26}>
                  <p className="mt-5 max-w-md text-base leading-relaxed text-clan-muted">{c.body}</p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
